/**
 * BLOCK: Brands Block.
 *
 * Registering a basic block with Gutenberg.
 * Simple block, renders and saves the same content without any interactivity.
 */

/**
 * External dependencies
 */
import { HeaderIcon } from '~cartzillagb/icons'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { disabledBlocks, i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'

export const schema = {
	blockId: {
		type: 'string',
		default: '',
	},

	enableCarousel: {
		type: 'boolean',
		default: false,
	},

	enableContainer: {
		type: 'boolean',
		default: true,
	},

	number: {
		type: 'number',
		default: 12,
	},

	columns: {
		type: 'number',
		default: 4,
	},

	slug: {
		type: 'array',
		default: [],
	},

	orderby: {
		type: 'string',
		default: 'name',
	},

	order: {
		type: 'string',
		default: 'ASC',
	},

	hide_empty: {
		type: 'boolean',
		default: false,
	},

	// Carousel Options
	slidesToShow: {
		type: 'number',
		default: 4,
	},

	slidesToShowLaptop: {
		type: 'number',
		default: 4,
	},

	slidesToShowTablet: {
		type: 'number',
		default: 3,
	},

	slidesToShowMobile: {
		type: 'number',
		default: 2,
	},
}

export const name = 'czgb/brands'

export const settings = {
	title: __( 'Brands', i18n ),
	description: __( 'Add brands block.', i18n ),
	icon: HeaderIcon,
	example: {},
	category: 'cartzillagb',
	keywords: [
		__( 'Brands', i18n ),
		__( 'CartzillaGB', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// cartzillaGB modules.
    modules: {
    	'advanced-responsive': true,
        'block-title': true,
    },
}
